<template>
  <view class="city-main">
    <view class="city-item city-item-cn">
      <view class="city-name-cn">{{ info.city_name_cn }}</view>
      <view class="city-country-name-cn">
        {{ info.country_name_cn }}
      </view>
    </view>
    <view class="city-item city-item-en">
      <view class="city-name-en">
        {{ info.city_name_en }}
      </view>
      <view class="city-country-name-en">
        {{ info.country_name_en }}
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      info: Object
    },
    methods: {}
  })
</script>

<style scoped lang="stylus" >
  .city-main
    display flex
    flex-direction column
    font-size 12px
  .city-item
    display flex
    &-cn
      line-height 20px
    &-en
      margin-top 2px
      line-height 17px
  .city
    &-name-cn
      font-size 14px
      color #000000
    &-country-name-cn
      color #666666
      margin-left 8px
    &-name-en
      color #999999
    &-country-name-en
      color #bbbbbb
      margin-left 8px
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
</script>
